import { Paper, styled } from '@mui/material';

// temp
export const GridItem = styled(Paper)(() => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
}));
